import React from "react";

function DefaultScreen() {
  return <img alt="homepage-cover" src={require("src/assets/images/homepage.png")} />
}

export default DefaultScreen;
